import { connect } from "react-redux";
import { getLevel, getLoading } from "../../reducers/crossword/selectors";
import {
  toggleSettings,
  toggleLevels,
  togglePrizes
} from "../../reducers/ui/actions";
import { regenerate } from "../../reducers/crossword/uriActions";
import { getPlayerPrizeIds } from "../../reducers/user/selectors";
import {
  getShowLevels,
  getShowPrizes,
  getShowSettings
} from "../../reducers/ui/selectors";

import NavBar from "./NavBar";

const mapStateToProps = state => ({
  level: getLevel(state),
  prizes: getPlayerPrizeIds(state).length,
  loading: getLoading(state),
  showLevels: getShowLevels(state),
  showSettings: getShowSettings(state),
  showPrizes: getShowPrizes(state)
});

const mapDispatchToProps = dispatch => ({
  toggleSettings: () => dispatch(toggleSettings()),
  toggleLevels: () => dispatch(toggleLevels()),
  togglePrizes: () => dispatch(togglePrizes()),
  regenerate: () => dispatch(regenerate())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NavBar);



// WEBPACK FOOTER //
// ./src/components/NavBar/NavBarContainer.js